export default {
  state: {
    status: "",
    login: null,
    load: null,
    page: null,
  },

  mutations: {
    SET_PRELOGIN(state, login) {
      state.login = login;
      state.status = "prelogin";
    },

    SET_LOGIN(state, login) {
      state.login = login;
      state.status = "loggedin";
    },

    SET_LOGOUT(state) {
      state.login = null;
      state.status = "";
    },

    SET_LOAD(state, data) {
      state.load = data;
    },
    SET_PAGE(state, page) {
      state.page = page;
    },
  },

  actions: {
    ADD_PRELOGIN({ commit }, user) {
      return new Promise((resolve, reject) => {
        try {
          commit("SET_PRELOGIN", user);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    ADD_LOGIN({ commit }, login) {
      return new Promise((resolve, reject) => {
        try {
          commit("SET_LOGIN", login);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    ADD_LOGOUT({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          commit("SET_LOGOUT");
          commit("SET_PAGE", null);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    ADD_LOAD({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit("SET_LOAD", payload);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    ADD_PAGE({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit("SET_PAGE", payload);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  getters: {
    // isLoggedIn: state => !!state.token,
    GET_LOGIN_STATUS: (state) => state.status,
    GET_LOGIN: (state) => state.login,
    GET_LOAD: (state) => state.load,
    GET_PAGE: (state) => state.page,
  },
};
